import React from "react";
import Feedback from "./Feedback";
import "./Floaticons.css";

function Floaticons() {
  return (
    <>
      <div className="float-wrap">
        <div className="floatIcon-innerWrap">
          <Feedback />
        </div>
      </div>
    </>
  );
}

export default Floaticons;
